<template>
  <div>
    <div v-for="group of groupedStandards" :key="group.standard_set_code">
      <h2 v-if="group.standardSetCode === 'CA-ELD'">English Learner Standards</h2>
      <h2 v-else>{{ standardHeading(group.standardSetCode) }}</h2>
      <h3 v-if="group.standardSetCode === 'CA-ELD'">{{ standardHeading(group.standardSetCode) }}</h3>
      <StandardsAccordion
        :standards="group.standards"
        :show-edit-link="showEditLink"
        :should-expand-first-standard="shouldExpandFirstStandard"
      />
    </div>
  </div>
</template>

<script>
import StandardsAccordion from '@/components/goals/StandardsAccordion'
import { mapGetters } from 'vuex'
import { headingsForStandardSetCode } from '@/components/goals/common/standard_headings.js'

export default {
  name: 'GoalContentPageStandards',
  components: {
    StandardsAccordion
  },
  props: {
    groupedStandards: {
      type: Array,
      default() {
        return []
      }
    },
    contentProfileId: {
      type: String,
      required: true
    },
    showEditLink: {
      type: Boolean,
      default: false
    },
    shouldExpandFirstStandard: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    standardHeading(setCode) {
      return headingsForStandardSetCode(setCode, { profileId: this.contentProfileId })
    }
  }
}
</script>
